import { render, staticRenderFns } from "./ParticipantTypesField.vue?vue&type=template&id=1d06ca1a"
import script from "./ParticipantTypesField.vue?vue&type=script&lang=js"
export * from "./ParticipantTypesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports